import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const WebinarPage: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-green-500/30" data-id="element-2431">
      {/* Header */}
      <header className="py-6 text-center border-b border-gray-800/50" data-id="element-2432"></header>

      <main className="max-w-2xl mx-auto px-4 py-8 md:py-12" data-id="element-2433">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-2434">
          {/* Hero Image */}
          <div className="relative rounded-2xl overflow-hidden mb-8 shadow-2xl shadow-black/50 ring-1 ring-white/10" data-id="element-2435">
            {/* Desktop image */}
            <img src="https://cdn.magicpatterns.com/uploads/iXzoZySTwsDcssGmHJToA2/POZOR_POHODLNE_SE_USAD_A_POSLOUCHEJ._TYTO_RADY_TI_UKAZOU_CESTU_K_VYSNENE_POSTAVE.jpg" alt="Pozor, pohodlně se usaď a poslouchej" className="hidden md:block w-full h-auto object-cover" data-id="element-2436" />
            {/* Mobile image */}
            <img src="https://cdn.magicpatterns.com/uploads/raMXKtrdFHNyHXV2qXxTVy/POZOR_POHODLNE_SE_USAD_A_POSLOUCHEJ._TYTO_RADY_TI_UKAZOU_CESTU_K_VYSNENE_POSTAVE_(1).jpg" alt="Pozor, pohodlně se usaď a poslouchej" className="block md:hidden w-full h-auto object-cover" data-id="element-2437" />
          </div>

          {/* Text Section */}
          <div className="space-y-6 mb-10 text-center" data-id="element-2438">
            <div className="inline-block px-4 py-1.5 rounded-full border border-green-500/30 bg-green-500/10 text-green-500 font-bold text-sm md:text-base shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-2439">
              [ Webinář Zpřístupněn! 🔓 ]
            </div>

            <h1 className="text-2xl md:text-3xl font-bold leading-tight text-white" data-id="element-2440">
              💪 10 rad, které pomohly mně i mým klientům dosáhnout vysněné
              postavy už za 90 dní. 🔥
            </h1>
          </div>

          {/* Recommendation text */}
          <div className="space-y-4 mb-10 text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-2441">
            <p data-id="element-2442">
              Doporučuji si vyhradit přibližně{' '}
              <strong className="text-white" data-id="element-2443">10 minut svého času</strong>. Každá
              rada trvá jen cca 1 minutu, ale dohromady ti můžou dát{' '}
              <strong className="text-white" data-id="element-2444">výsledky</strong>, po kterých{' '}
              <strong className="text-white" data-id="element-2445">toužíš už odjakživa</strong>. 🔥
            </p>
            <p data-id="element-2446">
              ⚡ A pokud chceš{' '}
              <strong className="text-white" data-id="element-2447">ušetřit čas</strong>, klidně si
              video zrychli — hlavní je, abys ty informace{' '}
              <strong className="text-white" data-id="element-2448">opravdu využil</strong>.
            </p>
          </div>

          {/* Video Intro Text */}
          <p className="text-center text-base md:text-lg text-gray-400 mb-6 tracking-wide" data-id="element-2449">
            Pusť si video, ve kterém se dozvíš o{' '}
            <span className="text-green-400 font-semibold" data-id="element-2450">10 radách</span>
          </p>

          {/* Video */}
          <div className="mb-12 relative w-full aspect-video rounded-2xl overflow-hidden shadow-xl border border-gray-800" data-id="element-2451">
            <iframe src="https://www.veed.io/embed/20a1fa25-a75a-44b2-99d7-b43a0a9a667a?watermark=0&color=&sharing=1&title=0" className="absolute inset-0 w-full h-full" frameBorder="0" title="Webinar Video" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen data-id="element-2452" />
          </div>

          {/* Text below video */}
          <div className="space-y-6 mb-10 text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-2453">
            <p data-id="element-2454">
              Pokud tě tohle video{' '}
              <strong className="text-white" data-id="element-2455">zaujalo</strong>, je dost možné, že
              jsi v něm slyšel něco, co jsi{' '}
              <strong className="text-white" data-id="element-2456">doposud nikdy neslyšel</strong>.
            </p>
            <p data-id="element-2457">
              Možná právě teď začínáš chápat, že{' '}
              <strong className="text-white" data-id="element-2458">růst svalů není o náhodě</strong>,
              ale o <strong className="text-white" data-id="element-2459">systému</strong>.
            </p>
            <p data-id="element-2460">
              A pokud chceš vědět,{' '}
              <strong className="text-white" data-id="element-2461">
                jak přesně tenhle systém funguje
              </strong>{' '}
              a jak ho můžeš začít využívat i ty k{' '}
              <strong className="text-white" data-id="element-2462">
                dosažení své vysněné postavy
              </strong>
              , klikni na tlačítko níže a zjisti více o{' '}
              <strong className="text-white" data-id="element-2463">BHS – Body Hack System</strong>.
            </p>
          </div>

          {/* CTA Box */}
          <div className="mb-16" data-id="element-2464">
            <button onClick={() => navigate('/bhs')} className="w-full bg-green-500 hover:bg-green-400 text-black font-black text-xl py-5 rounded-xl transition-all duration-300 shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.5)] active:scale-[0.98]" data-id="element-2465">
              CHCI VĚDĚT VÍCE O BHS!
            </button>
          </div>

          {/* Footer Link */}
          <div className="text-center pb-8" data-id="element-2466">
            <a href="#" className="text-sm text-gray-500 hover:text-gray-300 underline transition-colors" data-id="element-2467">
              Privacy Policy
            </a>
          </div>
        </motion.div>
      </main>
    </div>;
};